export const capitalizeCamelCase = (text: string) => {
  const regex = /([a-z])([A-Z])/g;
  const result = text.replace(regex, "$1 $2");
  return result.charAt(0).toUpperCase() + result.slice(1);
};
